import { mapToCamelCase } from '@consigli/utils';
import { z } from 'zod';
import { getPaginationResponseSchema } from './pagination';
export const FeedbackType = {
    SKILL: 'SKILL',
    ERROR: 'ERROR',
    GENERAL: 'GENERAL',
};
export const FeedbackTypeLabels = {
    [FeedbackType.GENERAL]: 'General',
    [FeedbackType.SKILL]: 'Skill',
    [FeedbackType.ERROR]: 'Error',
};
export const submitFeedbackRequestSchema = z
    .object({
    type: z.nativeEnum(FeedbackType),
    service: z.string().optional(),
    message: z.string(),
})
    .strict();
export const submitFeedbackResponseSchema = z
    .object({
    id: z.string().uuid(),
    type: z.nativeEnum(FeedbackType),
    service: z.string().nullable(),
    message: z.string(),
    created_at: z.string().datetime(),
    user_email: z.string(),
})
    .strict()
    .transform(mapToCamelCase);
export const feedbackSchema = z
    .object({
    id: z.string().uuid(),
    type: z.nativeEnum(FeedbackType),
    service: z.string().nullable(),
    message: z.string(),
    created_at: z.string().datetime(),
    user_email: z.string(),
})
    .strict()
    .transform(mapToCamelCase);
export const getFeedbackRequestSchema = z
    .object({
    page: z.number().int().optional(),
    pageSize: z.number().int().optional(),
    type: z.nativeEnum(FeedbackType).optional(),
    service: z.string().optional(),
    createdAtFrom: z.string().optional(),
    createdAtTo: z.string().optional(),
})
    .strict();
export const getFeedbackResponseSchema = getPaginationResponseSchema(feedbackSchema);
